import { render, staticRenderFns } from "./HrEmployeeLoanCompanyUpdate.vue?vue&type=template&id=ab053f5a&lang=pug&"
import script from "./HrEmployeeLoanCompanyUpdate.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeLoanCompanyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrEmployeeLoanCompanyUpdate.vue"
export default component.exports